module.exports = __webpack_public_path__ + "img/instructions_w.svg";